module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_8011.c078a9df.png";